export const EARN_REFERENCE_PREFIX = 'EARN_REF'
export const EPC_TAKES_EARN_RETAINED_EARNINGS_PERCENTAGE = 100
